function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="12" height="7" viewBox="0 0 12 7" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.525 6.734a.884.884 0 0 1-1.263 0 .917.917 0 0 1 0-1.283L5.368.266a.884.884 0 0 1 1.264 0l5.106 5.185a.917.917 0 0 1 0 1.283.884.884 0 0 1-1.264 0L5.998 2.188 1.525 6.734z" fill="currentColor" fillRule="evenodd" /></svg>;
});